import React from 'react';
import Wetter from '../components/Wetter';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterJochberg() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="wetter-jochberg-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="wetter-jochberg-heading">WETTER</h1>
        </div>

        <Wetter ort="jochberg" />
      </div>
    </div>
  );
}

export default WetterJochberg;
